import moment from "moment";

const regexIso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;

export function convertDateStringsToDates(input: $TSFixMe) {
    // Ignore things that aren't objects.
    if (typeof input !== "object") return input;

    for (let key in input) {
        if (!input.hasOwnProperty(key)) continue;

        const value = input[key];
        let match;
        // Check for string properties which look like dates.
        if (typeof value === "string" && (match = value.match(regexIso8601))) {
            
            const date = moment.utc(match[0], moment.ISO_8601, true);
            if (date.isValid()) {
                const milliseconds = date.toDate();
                if (!isNaN(milliseconds as $TSFixMe)) {
                    input[key] = new Date(milliseconds);
                }
            }
        } else if (typeof value === "object") {
            // Recurse into object
            convertDateStringsToDates(value);
        }
    }
}

export function createJsonParseReviver(): (key: string, value: any) => any {
    return (key: string, value: any) => {
        if (typeof value === "string") {
            const match = value.match(regexIso8601);
            if (match) {
                const date = moment.utc(match[0], moment.ISO_8601, true);
                if (date.isValid()) {
                    const milliseconds = date.toDate();
                    if (!isNaN(milliseconds as $TSFixMe)) {
                        return new Date(milliseconds);
                    }
                }
            }
        }
        return value;
    };
}